(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lucid-pdp-lab"] && !Shopify.designMode) return;
  try {
    
  // Reiner Anzeige-Mock: der gesamte Zustand lebt im Browser.
  // Beide Tabellen sind Anzeige zur Appstle-Bundle-Regel "Bau deine Box".
  // Herleitung, Stufensaetze und Messprotokoll stehen in PREISE.md.
  //
  // ACHTUNG, hier lag schon einmal ein Fehler: Frueher stand hier
  // "Abo = x0,8 gerundet". Diese Rechnung fuehrt der Shop NIE aus. Er rechnet
  // in zwei Schritten - erst Selling Plan -20 % (12,99 x 0,8 = 10,392, von
  // Shopify je Dose auf 10,39 abgerundet), dann die Mengenstufe auf diese
  // kleinere Basis. Solange Einmalkauf und Abo denselben Stufensatz teilen,
  // verfehlt das Abo jeden runden Punkt um einen Cent (39,98 statt 39,99).
  //
  // Die ABO-Werte unten sind daher der gemessene IST-Stand des Shops, nicht
  // der Wunschpreis. Sollen sie auf ,99 landen, braucht die Bundle-Regel
  // separateTiersByPurchaseType und eigene Abo-Saetze (3,7777 / 7,6227 /
  // 10,1861 / 12,0170 / 13,3903 / 14,4583 / 15,3128 %) - Notion M51, bewusst
  // zurueckgestellt. Wer daran dreht, misst nach - nicht rechnen.
  const EINMAL = { 4: 49.99, 5: 59.99, 6: 69.99, 7: 79.99, 8: 89.99, 9: 99.99, 10: 109.99 };
  const ABO = { 4: 39.98, 5: 47.98, 6: 55.98, 7: 63.98, 8: 71.98, 9: 79.98, 10: 87.98 };
  const BASIS_JE_DOSE = 12.99; // Streichpreis-Basis: einzelne Dose im Einzelkauf
  // Die Stufensaetze der Appstle-Regel (PREISE.md). Gebraucht nur ausserhalb
  // des Euro: Dort kommt der Dosenpreis aus der Preisliste des Marktes (CHF:
  // Festpreis 12.99) - oder, fehlt er dort, aus Shopifys Umrechnung mit
  // Tageskurs. Eine feste Tabelle waere dann still falsch. Gerechnet wird wie
  // die Discount Function selbst - einmal auf die Zwischensumme:
  // Rabatt = runden(Anzahl x Stueckpreis x Satz). Auf 12,99 / 10,39 ergibt
  // das exakt EINMAL/ABO oben, in EUR wie in CHF (13.10. per
  // draftOrderCalculate gemessen: 4 Dosen CHF 49.99, im Abo CHF 39.98).
  const STUFENSATZ = { 4: 0.0379, 5: 0.076367, 6: 0.102, 7: 0.1203, 8: 0.134, 9: 0.1447, 10: 0.153272 };
  const POUCHES_JE_DOSE = 15;
  const MIN = 4;
  const MAX = 10;

  document.querySelectorAll('[data-lucid-lab]').forEach((root) => {
    const isStarterset = root.hasAttribute('data-lab-starterset');

    // ---- Preise je Waehrung ----
    // Euro: die gemessenen Tabellen oben. Starterset: Festpreis-Produkt an der
    // Discount Function vorbei, also Preis, Abo-Preis und Streichpreis direkt
    // vom Produkt (in jeder Waehrung). Jede andere Waehrung: Staffel aus dem
    // Dosenpreis dieser Waehrung. Alle Betraege kommen aus Liquid in Cent/Rappen.
    const currency = root.dataset.currency || 'EUR';
    const cents = (v) => (v && Number(v) > 0 ? Number(v) : 0);
    const unitCents = cents(root.dataset.unitPrice);
    const unitAboCents = cents(root.dataset.unitPriceAbo) || unitCents;
    const compareCents = cents(root.dataset.comparePrice);
    const staffel = (stueck) => {
      const t = {};
      for (let n = MIN; n <= MAX; n++) t[n] = (n * stueck - Math.round(n * stueck * STUFENSATZ[n])) / 100;
      return t;
    };
    let einmal = EINMAL;
    let abo = ABO;
    let basis = BASIS_JE_DOSE;
    if (isStarterset && unitCents) {
      einmal = { [MIN]: unitCents / 100 };
      abo = { [MIN]: unitAboCents / 100 };
      // Streichpreis nur, wenn er wirklich ueber dem Preis liegt. Fehlt der
      // compare_at_price (etwa ein Festpreis in einer Preisliste ohne
      // Streichpreis) oder liegt er darunter, ist die Basis der Preis selbst -
      // dann bleibt der Streichpreis unten aus, statt CHF 49.99 neben einem
      // durchgestrichenen CHF 49.99 zu zeigen.
      basis = (compareCents > unitCents ? compareCents : unitCents) / 100 / MIN;
    } else if (currency !== 'EUR' && unitCents) {
      einmal = staffel(unitCents);
      abo = staffel(unitAboCents);
      basis = unitCents / 100;
    }
    const tabelle = () => (mode === 'abo' ? abo : einmal);
    const streich = (n) => Math.round(basis * n * 100) / 100;

    const tiles = [...root.querySelectorAll('[data-lab-tile]')];
    const cta = root.querySelector('[data-lab-cta]');
    const summary = root.querySelector('[data-lab-summary]');
    const price = root.querySelector('[data-lab-price]');
    const strike = root.querySelector('[data-lab-strike]');
    const savings = root.querySelector('[data-lab-savings]');
    const savingsAmount = root.querySelector('[data-lab-savings-amount]');
    const unitDose = root.querySelector('[data-lab-unit-dose]');
    const countLine = root.querySelector('[data-lab-count-line]');
    const unitBoost = root.querySelector('[data-lab-unit-boost]');
    const nudge = root.querySelector('[data-lab-nudge]');
    const codeHint = root.querySelector('[data-lucid-code-hint]');
    const modeInfo = root.querySelector('[data-lab-modeinfo]');
    const modeGroup = root.querySelector('[data-lab-mode-default]');
    const tierrow = root.querySelector('[data-lab-tierrow]');
    const tierEls = [...root.querySelectorAll('[data-lab-tier]')];
    const progress = root.querySelector('[data-lab-progress]');
    const progressLabel = root.querySelector('[data-lab-progress-label]');
    const sticky = root.querySelector('[data-lab-sticky]');
    const stickyCta = root.querySelector('[data-lab-sticky-cta]');
    // Startwert kommt aus dem Markup (siehe data-lab-mode-default oben)
    let mode = modeGroup ? modeGroup.dataset.labModeDefault : 'abo';
    let lastN = -1;
    // Kaufvorgang der CTA: null = bereit, 'adding' = /cart/add (samt
    // Drawer-Inhalt) laeuft, 'checkout' / 'cart' = liegt im Warenkorb, die
    // Seite ist auf dem Weg dorthin. Im Drawer-Modus geht es nach 'adding'
    // direkt zurueck auf null - die Seite bleibt ja stehen.
    // Lebt nur hier - die Beschriftung leitet render() daraus ab (siehe
    // addToCart unten, dort auch, warum pagehide/pageshow ihn zuruecksetzen).
    let busy = null;
    const BUSY_LABEL = { adding: 'Wird hinzugefügt …', checkout: 'Weiter zur Kasse …', cart: 'Weiter zum Warenkorb …' };
    // Ticker-Gedaechtnis je Preiszahl (null = kein Vorwert, kein Lauf)
    const last = { price: null, strike: null, saved: null, dose: null, boost: null, cta: null, pct: null, tier: {} };

    // Geldbetraege in der Schreibweise, die Shopifys money-Filter fuer die
    // Waehrung des Kunden benutzt - Vorlage ist data-money-sample (1234,56 im
    // Shop-Format, z. B. "1.234,56 €"). So zeigen Buy-Box und Warenkorb
    // dieselbe Schreibweise, auch in CHF. Passt die Vorlage nicht ins Muster
    // (etwa ein Format ohne Nachkommastellen), formatiert der Browser selbst -
    // in Euro genau wie vor der CHF-Umstellung.
    const muster = (root.dataset.moneySample || '').match(/^(\D*)1(\D?)234(\D)56(\D*)$/);
    const geld = (n) => {
      if (!muster) {
        if (currency !== 'EUR') return n.toLocaleString('de-CH', { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
        return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      }
      const [ganz, rest] = (Math.round(n * 100) / 100).toFixed(2).split('.');
      return muster[1] + ganz.replace(/\B(?=(\d{3})+(?!\d))/g, muster[2]) + muster[3] + rest + muster[4];
    };
    const total = () => tiles.reduce((s, t) => s + Number(t.querySelector('[data-lab-count]').value || 0), 0);

    // Zahl von alt nach neu hochlaufen lassen (Anzeigetafel-Effekt)
    function tickNumber(el, from, to, format, duration) {
      if (from === null || from === to || !window.requestAnimationFrame) {
        el.innerHTML = format(to);
        return;
      }
      el.classList.remove('lucid-lab__tick');
      void el.offsetWidth;
      el.classList.add('lucid-lab__tick');
      const start = performance.now();
      let done = false;
      const step = (now) => {
        if (done) return;
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        el.innerHTML = format(from + (to - from) * eased);
        if (t < 1) requestAnimationFrame(step); else done = true;
      };
      requestAnimationFrame(step);
      // Hintergrund-Tabs frieren requestAnimationFrame ein - Endwert trotzdem setzen
      setTimeout(() => { if (!done) { done = true; el.innerHTML = format(to); } }, duration + 80);
    }

    function renderTiers(n) {
      // Fenster aus 3 Stufen: aktive Stufe ganz links, rechts die naechsten
      // Ziele; ab Stufe 9/10 bleibt das Fenster am rechten Rand stehen.
      const start = Math.max(4, Math.min(n - 1, 8));
      const offset = start - 4;
      tierrow.style.transform = 'translateX(calc(' + -offset + ' * ((100% + 8px) / 3)))';
      const table = tabelle();
      tierEls.forEach((el) => {
        const stufe = Number(el.dataset.labTier);
        const reached = n >= MIN && stufe <= Math.min(n, MAX);
        el.classList.toggle('is-active', n >= MIN && stufe === Math.min(n, MAX));
        el.classList.toggle('is-done', n >= MIN && stufe < Math.min(n, MAX));
        el.querySelector('[data-lab-tier-verb]').textContent = reached ? 'Du sparst' : 'Spare';
        // Das Starterset kennt nur die Stufe 4 (die Stufenreihe ist dort ausgeblendet)
        if (table[stufe] === undefined) return;
        const amount = Math.round((streich(stufe) - table[stufe]) * 100) / 100;
        tickNumber(el.querySelector('[data-lab-tier-amount]'), last.tier[stufe] === undefined ? null : last.tier[stufe], amount, geld, 650);
        last.tier[stufe] = amount;
      });
      // Balken-Psychologie: er startet schon im Gruenen (12 %), fuellt sich
      // bis 4 Richtung Mindestbox, steht ab 4 bei ~78 % und rutscht bei
      // jeder neuen Stufe kurz zurueck, um wieder aufzufuellen - parallel
      // zum Stufen-Fenster.
      if (n < MIN) {
        progress.style.width = Math.round(12 + (n / MIN) * 58) + '%';
      } else if (n >= MAX) {
        progress.style.width = '100%';
      } else if (n !== lastN) {
        progress.style.transition = 'none';
        progress.style.width = '34%';
        void progress.offsetWidth;
        progress.style.transition = '';
        progress.style.width = '78%';
      }
      lastN = n;
      if (n >= MIN) {
        const nn = Math.min(n, MAX);
        const preis = tabelle()[nn];
        const pct = Math.round((1 - preis / streich(nn)) * 100);
        progressLabel.classList.add('is-reached');
        if (last.pct === null) progressLabel.innerHTML = '✅ <span data-lab-pct></span> % Rabatt';
        tickNumber(progressLabel.querySelector('[data-lab-pct]'), last.pct, pct, (v) => String(Math.round(v)), 650);
        last.pct = pct;
      } else {
        progressLabel.classList.remove('is-reached');
        progressLabel.textContent = 'Mengenrabatt';
        last.pct = null;
      }
    }

    function render() {
      const n = total();
      nudge.classList.remove('is-error');
      delete nudge.dataset.kind;
      tiles.forEach((t) => {
        const c = Number(t.querySelector('[data-lab-count]').value);
        t.classList.toggle('has-count', c > 0);
        t.querySelector('[data-lab-countwrap]').hidden = c === 0;
      });
      renderTiers(n);

      if (n < MIN) {
        last.price = last.strike = last.saved = last.dose = last.boost = last.cta = null;
        summary.hidden = true;
        cta.classList.add('is-locked');
        cta.setAttribute('aria-disabled', 'true');
        cta.textContent = n === 0 ? 'Wähle 4 Dosen' : 'Noch ' + (MIN - n) + (MIN - n === 1 ? ' Dose wählen' : ' Dosen wählen');
        nudge.textContent = '4 Dosen mindestens. Mehr Dosen = mehr Rabatt.';
      } else {
        const p = tabelle()[n];
        const base = streich(n);
        summary.hidden = false;
        const saved = Math.round((base - p) * 100) / 100;
        tickNumber(price, last.price, p, geld, 650);
        strike.hidden = base <= p;
        tickNumber(strike, last.strike, base, geld, 650);
        savings.hidden = saved <= 0;
        tickNumber(savingsAmount, last.saved, saved, geld, 650);
        countLine.textContent = n + ' Dosen\u00a0\u00a0·\u00a0\u00a0';
        tickNumber(unitDose, last.dose, p / n, geld, 650);
        tickNumber(unitBoost, last.boost, p / (n * POUCHES_JE_DOSE), geld, 650);
        cta.classList.remove('is-locked');
        cta.removeAttribute('aria-disabled');
        // Waehrend eines Kaufs steht dort die Busy-Beschriftung (unten), der
        // Preis-Span ist dann weg. Fehlt er, wird er neu gebaut statt
        // vorausgesetzt - sonst warf jede Auswahl nach einem fehlgeschlagenen
        // Kauf einen TypeError und die Buy-Box blieb stehen.
        if (!busy) {
          if (!cta.querySelector('[data-lab-cta-price]')) {
            cta.innerHTML = 'In den Warenkorb → <span data-lab-cta-price></span>';
            last.cta = null;
          }
          tickNumber(cta.querySelector('[data-lab-cta-price]'), last.cta, p, geld, 650);
        }
        last.price = p; last.strike = base; last.saved = saved; last.dose = p / n; last.boost = p / (n * POUCHES_JE_DOSE); last.cta = p;
        // Formulierung bleibt "Spar nochmal X, wenn du 1 Dose hinzufügst" -
        // Franz, 15.10.2026, nach dem Vorschlag "Jede weitere Dose kostet
        // dich nur 10,00 EUR statt 12,99 EUR": "dann war die alte
        // Formulierung doch schon gut, lass wie es war."
        if (n < MAX && tabelle()[n + 1] !== undefined) {
          const table = tabelle();
          const extra = Math.round((basis - (table[n + 1] - table[n])) * 100) / 100;
          nudge.textContent = 'Spar nochmal ' + geld(extra) + ', wenn du 1 Dose hinzufügst';
          // Rechnet ohne Code; mit aktivem Code waere die Zahl falsch, die
          // Zeile verschwindet dann per CSS (.lucid-lab__nudge[data-kind]).
          nudge.dataset.kind = 'upsell';
        } else {
          nudge.textContent = 'Volle Box - maximaler Rabatt';
        }
      }
      if (codeHint) codeHint.dataset.mode = mode;
      modeInfo.textContent = mode === 'abo' ? 'Alle 30 Tage. Nie leer ausgehen. Jederzeit kündbar.' : '25 % teurer als im Abo';
      modeInfo.classList.toggle('is-warn', mode !== 'abo');
      if (busy) {
        [cta, stickyCta].forEach((b) => { b.textContent = BUSY_LABEL[busy]; b.setAttribute('aria-busy', 'true'); });
      } else {
        [cta, stickyCta].forEach((b) => b.removeAttribute('aria-busy'));
        stickyCta.textContent = cta.classList.contains('is-locked') ? cta.textContent : n + ' Dosen in den Warenkorb → ' + geld(last.cta);
      }
      stickyCta.classList.toggle('is-locked', cta.classList.contains('is-locked'));
    }

    // Stufen-Kasten antippen = Box auf genau diese Dosenzahl setzen.
    // Aufgefuellt wird in Kachel-Reihenfolge, und die folgt seit 14.10.2026
    // dem Lagerbestand (siehe lab_tile_order im Markup) - die vollste Sorte
    // bekommt also die Extra-Dosen. Im Rundlauf, bei Rueckfall-Reihenfolge
    // Mango, Berry Blend, Lemon-Lime, Mint: 5 = jede Sorte einmal plus ein
    // zweites Mango, 6 = 2 Mango, 2 Berry, 1 Lemon-Lime, 1 Mint. Schon
    // gewaehlte Dosen bleiben stehen; es wird nur auf- oder abgefuellt
    // (abgebaut wird bei der Sorte mit den meisten Dosen, bei Gleichstand
    // bei der hinteren, also bestandsaermeren).
    const setTotal = (target) => {
      const els = tiles.map((t) => t.querySelector('[data-lab-count]'));
      const vals = els.map((c) => Number(c.value) || 0);
      let n = vals.reduce((s, v) => s + v, 0);
      while (n < target) {
        let i = 0;
        for (let k = 1; k < vals.length; k++) if (vals[k] < vals[i]) i = k;
        vals[i]++; n++;
      }
      while (n > target) {
        let i = vals.length - 1;
        for (let k = vals.length - 2; k >= 0; k--) if (vals[k] > vals[i]) i = k;
        vals[i]--; n--;
      }
      els.forEach((c, k) => { c.value = vals[k]; });
      render();
    };
    // Gesperrte CTA antippen = jede Sorte einmal, dann die Stufen-Reihe
    // buendig unter das Menue scrollen
    const fillFour = () => { if (total() === 0) setTotal(MIN); };
    const scrollToTiers = () => {
      const tiers = root.querySelector('.lucid-lab__tiers');
      const header = document.querySelector('.header');
      const offset = header ? header.getBoundingClientRect().bottom + 8 : 80;
      window.scrollTo({ top: tiers.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    };
    tierEls.forEach((el) => {
      const pick = () => setTotal(Number(el.dataset.labTier));
      el.addEventListener('click', pick);
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });
    // Appstle-Vertrag (Call 02.09. + Bundles-Doku): jede Dose eine normale
    // Warenkorbzeile mit den drei Line-Properties, im Abo zusaetzlich
    // selling_plan auf jeder Zeile; Rabatt zieht die Discount Function.
    // Starterset = eine Zeile (eigene SKU) mit selling_plan im Abo.
    const sellingPlan = root.dataset.sellingPlan;
    const bundleProps = {
      '_appstle-bb-id': root.dataset.bundleRef,
      '_appstle_bundles_type': root.dataset.bundleType,
      '__appstle-bb-name': root.dataset.bundleName,
    };
    // Wohin es nach dem Hinzufuegen geht, steht in data-after-add - globale
    // Theme-Einstellung "Nach dem Kaufen-Button" (Theme-Editor > Theme-
    // Einstellungen > Warenkorb), fuer Box und Starterset gleich:
    // - 'drawer' (Standard): Der Warenkorb-Drawer geht auf. Franz, 15.10.2026:
    //   In den ersten 7 Tagen kaufen die Wartelisten-Leute mit ihren Codes,
    //   und nur im Warenkorb steht am Codefeld der Hinweis aus #165
    //   ("Rabattcode und Mengenrabatt werden nicht addiert - es gilt
    //   automatisch der hoehere"). Im Checkout gibt es nur Shopifys
    //   Standardmeldung.
    // - 'checkout': direkt zur Kasse. GET /checkout baut den Checkout aus dem
    //   Warenkorb-Cookie; Zeilen-Properties, Selling Plan, Mengenrabatt der
    //   Discount Function und ein Code aus einem /discount/-Link kommen mit.
    //   Gedacht fuer die Zeit nach der Launch-Woche - umschalten im
    //   Theme-Editor, ohne Code-Aenderung.
    // Rueckfall in beiden Faellen, wenn der Drawer nicht kann (kein Drawer im
    // Theme, Modul nicht geladen, Warenkorb nicht lesbar): die Warenkorbseite
    // /cart, wie bis 15.10. immer.
    const afterAdd = root.dataset.afterAdd === 'checkout' ? 'checkout' : 'drawer';
    const checkoutUrl = root.dataset.checkoutUrl || '/checkout';
    const cartUrl = root.dataset.cartUrl || '/cart';
    // Haengt der Shop, gibt die CTA nach dieser Zeit wieder frei, statt fuer
    // immer "Wird hinzugefuegt" zu zeigen (vorher wird noch nachgesehen, ob
    // die Dosen trotzdem angekommen sind, siehe addToCart). Der Drawer-Inhalt
    // bekommt weniger: Die Dosen liegen dann schon im Warenkorb, es geht
    // notfalls auf /cart. 12 statt 8 s, seit am 15.10. der allererste Kauf
    // auf einer frisch angelegten Vorschau einmal auf /cart statt im Drawer
    // landete (vermutlich kalter Section-Render; in den Wiederholungen danach
    // nicht mehr).
    const ADD_TIMEOUT_MS = 15000;
    const DRAWER_TIMEOUT_MS = 12000;
    const CHECK_TIMEOUT_MS = 5000;
    // Artikel im Warenkorb, gefuehrt wie Horizons Cart-Icon (assets/cart-icon.js):
    // Startwert aus dem Markup, danach aus jedem 'cart:update' - Adds aus dem
    // Produktformular zaehlen dazu, alles andere (Warenkorbzeilen, Offer-Stack,
    // diese Buy-Box) meldet den neuen Stand. Gebraucht nur nach einem Abbruch
    // in addToCart, um zu sehen, ob die Dosen trotzdem angekommen sind.
    let cartCount = Number(root.dataset.cartCount) || 0;
    document.addEventListener('cart:update', (e) => {
      const data = (e.detail && e.detail.data) || {};
      const n = Number(data.itemCount);
      if (!Number.isFinite(n) || data.didError) return;
      cartCount = data.source === 'product-form-component' ? cartCount + n : n;
    });
    // Zaehlt pagehide. Kommt eine Antwort erst an, nachdem die Seite verlassen
    // und aus dem BF-Cache zurueckgeholt wurde, gehoert sie zu einem alten
    // Besuch: dann weder Drawer oeffnen noch weiterleiten noch Fehler zeigen.
    let pageEpoch = 0;

    const timedFetch = async (url, options, ms) => {
      const ctrl = window.AbortController ? new AbortController() : null;
      const timer = setTimeout(() => { if (ctrl) ctrl.abort(); }, ms);
      try {
        return await fetch(url, { ...options, signal: ctrl ? ctrl.signal : undefined });
      } finally {
        clearTimeout(timer);
      }
    };

    // Artikelzahl laut Shop, null wenn er nicht antwortet.
    const cartItemCount = async () => {
      try {
        const res = await timedFetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }, CHECK_TIMEOUT_MS);
        if (!res.ok) return null;
        const cart = await res.json();
        return Number.isFinite(cart.item_count) ? cart.item_count : null;
      } catch (e) {
        return null;
      }
    };

    const leaveTo = (where) => {
      busy = where;
      render();
      window.location.href = where === 'checkout' ? checkoutUrl : cartUrl;
    };

    // Drawer mit dem neuen Inhalt oeffnen - dieselbe Mechanik wie der
    // LP-Offer-Stack (assets/lucid-offer-stack.js): /cart/update.js liefert den
    // ganzen Warenkorb und rendert die Drawer-Section gleich mit, dann ein
    // 'cart:update'-Event, auf das Drawer, Cart-Icon und Warenkorb-Zeilen hoeren
    // (assets/events.js). Ist im Theme "Warenkorb automatisch oeffnen" an
    // (auto-open), oeffnet der Drawer sich darauf selbst, sonst hier per
    // open() - nie beides, ein zweites showModal() wirft in Safari.
    // Gibt false zurueck, wenn es nicht geht.
    const openDrawer = async () => {
      const drawer = document.querySelector('cart-drawer-component');
      if (!drawer || !window.customElements) return false;
      // cart-drawer.js ist ein Modul mit niedriger Prioritaet - kurz warten.
      const ready = await Promise.race([
        customElements.whenDefined('cart-drawer-component').then(() => true),
        new Promise((resolve) => setTimeout(() => resolve(false), 3000)),
      ]);
      if (!ready || typeof drawer.open !== 'function') return false;
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((n) => n.dataset.sectionId))];
      const body = new FormData();
      if (sectionIds.length) body.append('sections', sectionIds.join(','));
      const res = await timedFetch((root.dataset.updateUrl || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body,
      }, DRAWER_TIMEOUT_MS);
      if (!res.ok) return false;
      const cart = await res.json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'lucid-pdp-lab',
          data: { source: 'lucid-pdp-lab', itemCount: cart.item_count, sections: cart.sections },
        },
      }));
      if (!drawer.hasAttribute('auto-open')) drawer.open();
      return true;
    };

    const addToCart = async () => {
      if (busy) return;
      let items;
      if (isStarterset) {
        items = [{ id: Number(root.dataset.starterVariant), quantity: 1 }];
      } else {
        items = tiles
          .map((t) => ({ id: Number(t.dataset.variantId), quantity: Number(t.querySelector('[data-lab-count]').value) }))
          .filter((i) => i.quantity > 0 && i.id)
          .map((i) => ({ ...i, properties: bundleProps }));
      }
      if (!items.length) return;
      if (mode === 'abo' && sellingPlan) items = items.map((i) => ({ ...i, selling_plan: Number(sellingPlan) }));
      busy = 'adding';
      render();
      const epoch = pageEpoch;
      const countBefore = cartCount;
      const addedQty = items.reduce((sum, i) => sum + i.quantity, 0);
      try {
        const res = await timedFetch(root.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        }, ADD_TIMEOUT_MS);
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || ('HTTP ' + res.status));
        }
      } catch (e) {
        // Abbruch nach ADD_TIMEOUT_MS heisst nicht, dass nichts angekommen
        // ist: Der Shop kann /cart/add.js trotzdem ausgefuehrt haben. Ein
        // zweiter Tipp waere dann eine zweite Box - gleiche Zeilen
        // verschmelzen, aus 4 Dosen werden 8. Darum erst im Warenkorb
        // nachsehen: Ist er um die gewaehlten Dosen gewachsen, weiter wie bei
        // Erfolg. Sonst die CTA frei, aber mit der Bitte, erst den Warenkorb
        // anzusehen - die Anfrage kann auch nach dem Nachsehen noch ankommen.
        let landed = false;
        if (e.name === 'AbortError' && epoch === pageEpoch) {
          const now = await cartItemCount();
          landed = now !== null && now >= countBefore + addedQty;
        }
        if (!landed) {
          busy = null;
          render();
          if (epoch !== pageEpoch) return;
          let why = e.message;
          if (e.name === 'AbortError') why = 'keine Antwort vom Shop. Bitte schau in deinen Warenkorb, bevor du es noch einmal versuchst.';
          else if (e instanceof TypeError) why = 'keine Verbindung. Bitte noch einmal tippen.';
          nudge.textContent = 'Das hat nicht geklappt: ' + why;
          nudge.classList.add('is-error');
          return;
        }
      }
      // Liegt im Warenkorb.
      if (epoch !== pageEpoch) { busy = null; render(); return; }
      if (afterAdd === 'checkout') { leaveTo('checkout'); return; }
      let opened = false;
      try { opened = await openDrawer(); } catch (e) { opened = false; }
      if (!opened && epoch === pageEpoch) { leaveTo('cart'); return; }
      // Drawer ist offen, die Seite bleibt: CTA sofort wieder normal, damit
      // man nach dem Schliessen weiter waehlen und erneut hinzufuegen kann.
      busy = null;
      render();
    };

    // Zurueck-Taste nach dem Kauf (iOS Safari, Franz 15.10.2026): Safari legt
    // die Seite in den Back-Forward-Cache und stellt sie beim Zurueckgehen
    // EINGEFROREN wieder her - mitsamt "Wird hinzugefuegt …" und gesperrter
    // CTA, weil die alte Sperre nur ein Fehler zurueckgesetzt hat, nie die
    // geglueckte Weiterleitung. Darum: beim Verlassen (pagehide) zuruecksetzen,
    // damit schon der Schnappschuss sauber ist, und beim Wiederherstellen
    // (pageshow mit persisted) noch einmal, falls pagehide nicht kam. Gilt in
    // beiden Modi: auch im Drawer-Modus verlaesst man die Seite (Zur Kasse im
    // Drawer, Rueckfall auf /cart, Wegtippen mitten im Hinzufuegen).
    // visibilitychange bewusst nicht: ein Tab-Wechsel waehrend der Anfrage
    // wuerde die CTA sonst mitten im Kauf freigeben.
    const resetBusy = () => { if (busy) { busy = null; render(); } };
    window.addEventListener('pagehide', () => { pageEpoch++; resetBusy(); });
    window.addEventListener('pageshow', (e) => { if (e.persisted) resetBusy(); });

    [cta, stickyCta].forEach((b) => b.addEventListener('click', () => {
      if (busy === 'adding') return;
      // Liegt schon im Warenkorb, nur die Weiterleitung kam nicht an (etwa
      // abgebrochen): nicht noch einmal hinzufuegen, nur erneut losschicken.
      if (busy === 'checkout' || busy === 'cart') { leaveTo(busy); return; }
      if (b.classList.contains('is-locked')) {
        if (isStarterset) return;
        const wasEmpty = total() === 0;
        if (wasEmpty) fillFour();
        scrollToTiers();
        return;
      }
      addToCart();
    }));

    tiles.forEach((tile) => {
      const count = tile.querySelector('[data-lab-count]');
      const plus = tile.querySelector('[data-lab-plus]');
      const minus = tile.querySelector('[data-lab-minus]');
      const add = () => {
        if (total() >= MAX) return;
        count.value = Number(count.value) + 1;
        render();
      };
      const flash = (el) => {
        el.classList.remove('is-tapped');
        void el.offsetWidth;
        el.classList.add('is-tapped');
      };
      // Uber-Eats-Muster: Tap auf die Karte = +1; Stepper erscheint ab 1
      tile.addEventListener('click', (e) => {
        if (e.target.closest('button')) return;
        flash(tile);
        add();
      });
      tile.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flash(tile); add(); }
      });
      plus.addEventListener('click', () => { flash(plus); add(); });
      minus.addEventListener('click', () => {
        flash(minus);
        count.value = Math.max(0, Number(count.value) - 1);
        render();
      });
    });

    root.querySelectorAll('[data-lab-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        mode = btn.dataset.labMode;
        root.querySelectorAll('[data-lab-mode]').forEach((b) => b.classList.toggle('is-active', b === btn));
        render();
      });
    });

    // Pillenreihe: laeuft nach 5 s einmal nach rechts und wieder zurueck -
    // dieselbe Geste wie ein zu langer Songtitel. Ohne sie sieht man auf dem
    // Handy nur die ersten zwei Pillen und ahnt nicht, dass rechts mehr steht.
    // Startet erst, wenn die Reihe im Bild ist, laeuft genau einmal, und jede
    // eigene Wischbewegung setzt die 5 Sekunden neu.
    const pills = root.querySelector('.lucid-lab__pills');
    const calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (pills && !calm) {
      let armed = null;
      let back = null;
      const slack = () => pills.scrollWidth - pills.clientWidth;
      const run = () => {
        if (slack() < 8) return;
        pills.scrollTo({ left: slack(), behavior: 'smooth' });
        back = setTimeout(() => pills.scrollTo({ left: 0, behavior: 'smooth' }), 2200);
      };
      const arm = () => {
        clearTimeout(armed);
        clearTimeout(back);
        armed = setTimeout(run, 5000);
      };
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((ev) => {
        pills.addEventListener(ev, arm, { passive: true });
      });
      if (window.IntersectionObserver) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            io.disconnect();
            arm();
          });
        }, { threshold: 0.9 });
        io.observe(pills);
      } else {
        arm();
      }
    }

    // Galerie: eine Scroll-Spur, zwei Bedienwege. Wischen bewegt sie direkt
    // (CSS scroll-snap, kein JS im Weg), ein Thumbnail scrollt sie an die
    // passende Stelle. Beide Wege enden im selben scroll-Handler, deshalb
    // stimmt der aktive Thumb auch nach einer Wischgeste.
    const track = root.querySelector('[data-lab-track]');
    const slides = [...root.querySelectorAll('[data-lab-slide]')];
    const thumbsWrap = root.querySelector('[data-lab-thumbs]');
    const thumbs = [...root.querySelectorAll('.lucid-lab__thumb')];
    if (track && slides.length) {
      let current = 0;
      const markThumb = (i) => {
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
        // Aktives Thumbnail in die Leiste holen, ohne die Seite zu bewegen
        const t = thumbs[i];
        if (t && thumbsWrap) {
          const left = t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
          thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      };
      // Ein Video laeuft nur auf dem sichtbaren Slide. Verlaesst es das Bild,
      // faellt der Slide auf sein Standbild zurueck - sonst laufen zwei
      // Videos gleichzeitig und keins davon sieht man.
      const sync = (i) => {
        slides.forEach((slide, k) => {
          const video = slide.querySelector('[data-lab-slide-video]');
          if (!video) return;
          if (k === i) {
            slide.classList.add('is-playing');
            video.currentTime = 0;
            const p = video.play();
            if (p && p.catch) p.catch(() => slide.classList.remove('is-playing'));
          } else {
            video.pause();
            slide.classList.remove('is-playing');
          }
        });
      };
      const goTo = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => {
          if (i === current) { sync(i); return; }
          goTo(i);
        });
      });
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          if (!track.clientWidth) return;
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i === current || !slides[i]) return;
          current = i;
          markThumb(i);
          sync(i);
        });
      }, { passive: true });
      // Kein `ended`-Handler mehr: die Videos tragen `loop` und laufen, bis
      // der Slide das Bild verlaesst (sync pausiert sie dann).
      // Sicherheitsnetz wie bisher: haengt das Autoplay des ersten Videos
      // (Sparmodus, Hintergrund-Tab), faellt der Slide nach 12 s aufs
      // Standbild zurueck, statt schwarz zu bleiben.
      const first = slides[0] && slides[0].querySelector('[data-lab-slide-video]');
      if (first) {
        setTimeout(() => {
          if (slides[0].classList.contains('is-playing') && (first.paused || first.readyState < 3)) {
            slides[0].classList.remove('is-playing');
          }
        }, 12000);
      }
      markThumb(0);
    }

    // Versand-Timer: Countdown (Startwert zufaellig zwischen min und max
    // Minuten, je Browser-Sitzung gemerkt), danach neuer Lauf. Bewusst
    // ohne "morgen"/"heute": wer vormittags bestellt, bekommt noch am selben
    // Tag Versand, und ein Text, der zu jeder Uhrzeit stimmt, braucht keine
    // Cutoff-Logik (Robert, Slack #shopify, 16.10.2026).
    const timerEl = root.querySelector('[data-lab-timer]');
    if (timerEl) {
      const timerText = timerEl.querySelector('[data-lab-timer-text]');
      const tMin = Number(timerEl.dataset.timerMin) || 18;
      const tMax = Math.max(tMin, Number(timerEl.dataset.timerMax) || 83);
      const KEY = 'lucidLabTimerEnd';
      const newEnd = () => {
        const end = Date.now() + (tMin + Math.floor(Math.random() * (tMax - tMin + 1))) * 60000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
        return end;
      };
      let end = 0;
      try { end = Number(sessionStorage.getItem(KEY)) || 0; } catch (e) {}
      if (!end || end < Date.now()) end = newEnd();
      const renderTimer = () => {
        let left = Math.round((end - Date.now()) / 1000);
        if (left <= 0) { end = newEnd(); left = Math.round((end - Date.now()) / 1000); }
        const m = Math.floor(left / 60);
        const sec = left % 60;
        timerText.innerHTML = 'Bestell in <strong>' + m + ':' + (sec < 10 ? '0' : '') + sec + '</strong> f\u00fcr p\u00fcnktlichen Versand';
        timerEl.hidden = false;
      };
      renderTimer();
      setInterval(renderTimer, 1000);
    }

    // Sticky-Leiste, sobald die Inline-CTA aus dem Sichtfeld scrollt
    new IntersectionObserver((entries) => {
      sticky.hidden = entries[0].isIntersecting;
    }).observe(cta);

    root.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const target = document.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (isStarterset) {
      tiles.forEach((t) => { t.querySelector('[data-lab-count]').value = 1; });
    }
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
